import { useContextDeepAChatOptional } from '@/pocs/chat/composables/ctx-deepa-chat'
import type { DeepAChatContextNode } from '@/pocs/chat/types'

interface DeepAChatActionExecuteParams {
  nodes?: DeepAChatContextNode[]
}

export function useDeepBoxDeepAChatAction() {
  const { t } = useI18n()
  const chat = useContextDeepAChatOptional()

  const config = computed(() => ({
    id: 'DEEP_A_CHAT',
    title: t('node_data_table.actions.deepa_chat'),
    deepIcon: { name: 'deep-a' },
    available: !!chat?.isEnabled.value,
  }))

  function execute({ nodes }: DeepAChatActionExecuteParams = {}) {
    if (!chat?.isEnabled.value) return
    chat.open(nodes)
  }

  return { execute, config }
}
